import React from 'react'

function Classess() {
  return (
    <div>Classess</div>
  )
}

export default Classess